import { render, staticRenderFns } from "./TicoursesScheduledSurveyCreate.vue?vue&type=template&id=bc8139bc"
import script from "./TicoursesScheduledSurveyCreate.vue?vue&type=script&lang=js"
export * from "./TicoursesScheduledSurveyCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports